import type { BrokerConfig } from './types';

/**
 * Loads the runtime configuration mounted at /config.json.
 *
 * The config is intentionally not bundled at build time so the same SPA
 * image can deploy to every broker instance, distinguished only by the
 * config file the deployment compose-mounts.
 */
export async function loadConfig(): Promise<BrokerConfig> {
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(
      `Failed to load /config.json: ${response.status} ${response.statusText}`
    );
  }
  const data = (await response.json()) as BrokerConfig;
  validateConfig(data);
  return data;
}

function validateConfig(c: BrokerConfig): void {
  if (!c.instance?.name) throw new Error('config.instance.name is required');
  if (!c.branding?.title) throw new Error('config.branding.title is required');
  if (!Array.isArray(c.tiles)) throw new Error('config.tiles must be an array');

  // ADR-023 amendment §1 validation rules — sub-tenant must have parent.
  if (c.instance.type === 'sub-tenant' && !c.instance.parentTenantId) {
    throw new Error('config.instance.parentTenantId is required when type="sub-tenant"');
  }
  if (c.instance.type !== 'sub-tenant' && c.instance.parentTenantId) {
    throw new Error('config.instance.parentTenantId must be unset when type !== "sub-tenant"');
  }
}
